import { ADMIN_API } from '../AdminAPI';
import { createBranch, Branch, GameCategoryType } from '@golden/gdk-base';
import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
export function createPlatformService(api, trunk) {
    return {
        platforms: createBranch({
            trunk,
            branch: Branch.PLATFORMS,
            value: [],
            operator: () => api.fetch(ADMIN_API.GET_PLATFORM)
        }),
        getPlatformExcludeGolden() {
            return api.fetch(ADMIN_API.GET_EXCLUDE_GOLDEN_PLATFORM);
        },
        updatePlatform(data) {
            return api.fetch(ADMIN_API.PUT_PLATFORM, { data });
        },
        getGameList() {
            return api.fetch(ADMIN_API.GET_GAME_LIST).pipe(map((res) => (res.sort((a, b) => (a.category - b.category)))), map((res) => (res.sort((a, b) => ([GameCategoryType.VIDEO_GAME, GameCategoryType.FISH_CATCHER, GameCategoryType.ESPORT].includes(b.category) ? -1 : (a.category - b.category))))));
        },
        getFeedbackList(data) {
            return api.fetch(ADMIN_API.GET_FEEDBACK_LIST, { data }).pipe(map((res) => res.map((item) => ({
                ...convertUnixToDate(item, 'updated_at'),
                channels: item.channels.map((channel) => convertUnixToDate(channel, 'updated_at'))
            }))));
        },
        getFeedback(id) {
            return api.fetch(ADMIN_API.GET_FEEDBACK, { config: { urlParams: { id } } }).pipe(map((res) => ({
                ...convertUnixToDate(res, 'updated_at'),
                channels: res.channels.map((channel) => convertUnixToDate(channel, 'updated_at'))
            })));
        },
        updateFeedback(id, data) {
            return api.fetch(ADMIN_API.PUT_FEEDBACK, { data, config: { urlParams: { id } } });
        },
        getChannelList(platformId, gameId, isOnlyActive) {
            const data = {};
            if (gameId)
                data.game_id = gameId;
            if (isOnlyActive)
                data.is_only_active = 1;
            return api.fetch(ADMIN_API.GET_CHANNEL_LIST, { data, config: { urlParams: { id: platformId } } });
        },
        getFetchTasks() {
            return api.fetch(ADMIN_API.GET_FETCH_TASKS_LIST).pipe(map((res) => res.map((item) => convertUnixToDate(item, 'start_at', 'end_at', 'updated_at'))));
        },
        dispatchFetchTask(data) {
            return api.fetch(ADMIN_API.POST_FETCH_TASK, { data });
        },
        getFetchState(serialNumber) {
            return api.fetch(ADMIN_API.POST_FETCH_BTI, { data: { serial_number: serialNumber } });
        },
        getPlatformFee(game) {
            return api.fetch(ADMIN_API.GET_PLATFORM_FEE, { config: { urlParams: { game } } }).pipe(map((res) => res.map((item) => convertUnixToDate(item, 'month'))));
        },
        setPlatformFee(game, feeRates) {
            return api.fetch(ADMIN_API.PUT_PLATFORM_FEE, { data: { fee_rates: feeRates }, config: { urlParams: { game } } });
        },
        getPlatformFeeStatus() {
            return api.fetch(ADMIN_API.GET_PLATFORM_FEE_STATUS);
        },
        uploadImage(file) {
            const formData = new FormData();
            formData.append('file', file);
            return api.fetch(ADMIN_API.POST_IMAGE, { data: formData });
        },
        getChannels(game, page, search) {
            return api.fetch(ADMIN_API.GET_CHANNELS, { data: search ? { page, nameOrCode: search } : { page }, config: { urlParams: { game } } })
                .pipe(map((res) => {
                const newData = res.data.map((item) => convertUnixToDate(item, 'created_at'));
                return { ...convertUnixToDate(res, 'latest_channels_fetched'), data: newData };
            }));
        },
        createChannels(game, data) {
            return api.fetch(ADMIN_API.POST_CHANNELS, { data, config: { urlParams: { game } } });
        },
        updateChannel(channel, data) {
            return api.fetch(ADMIN_API.PUT_CHANNEL, { data, config: { urlParams: { channel } } });
        },
        deleteChannel(channel) {
            return api.fetch(ADMIN_API.DELETE_CHANNEL, { config: { urlParams: { channel } } });
        }
    };
}
//# sourceMappingURL=PlatformService.js.map